import API from '..';
const ENTITY = 'proposals';

export const filterProposals = ({
    companyId,
    date_render_filter = null,
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
    status = 'active',
    date_range_filter,
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            ...(companyId ? { company: companyId } : {}),
            date_range_filter,
            date_render_filter,
            order_by: orderBy,
            page: page,
            per_page: perPage,
            ...(searchText ? { search: searchText } : {}),
            sort: sortBy,
            status_flag: status,
        },
    });
